const Style = `
  <style>
    .benefits-list-module {
      background: #FEEBE3;
      padding: 40px 48px;
      display: flex;
      flex-direction: column;
      gap: 0;
    }

    .benefits-list-module ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    .benefits-list-module ul li {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: 12px;

      @media (max-width: 768px) {
        margin-bottom: 16px;
      }
    }

    .benefits-list-module__title {
      font-family: 'Spectral-ExtraLight';
      font-size: 38px;
      font-weight: 300;
      margin-top: 0;

      @media (max-width: 768px) {
        font-size: 28px;
      }
    }
  </style>
`;

export default Style;
